import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";

import "./SubscriptionManagement.css";

import visa from "../../assets/Images/visa.png";
import cc_generic from "../../assets/Images/cc_generic.png";
import amex from "../../assets/Images/amex.png";
import city_double_cash from "../../assets/Images/city_double_cash.png";
import check_everyday from "../../assets/Images/check_everyday.png";

import pwa_image from "../../assets/Images/pwa_image.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useFintechLayouts, usePaymentMethods, useActiveSubscriptions, useSubscriptionsPlans } from "../../services/AsaApiServices";
import SubscriptionManagementLogo from "./SubscriptionManagementLogo";
import { AsaStateContext } from '../../components/AsaStateProvider'
import SubscriptionManagementBase from "./SubscriptionManagementBase"
import {useAsaSessionPagesMutation,useAsaSession} from '../../services/AsaSessionServices'
import { IAsaSession, Plan, SessionPage } from "../../types/types";
import { Console } from "console";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";

const infoIcon = (isDarkMode:boolean) => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <rect width="24" height="24" fill={isDarkMode ?"#2C2C2C" : "#D9D9D9"}/>
  <g >
    <path d="M12.0003 16.75C12.2129 16.75 12.391 16.6781 12.5345 16.5343C12.6782 16.3906 12.75 16.2125 12.75 16V11.75C12.75 11.5375 12.6781 11.3593 12.5343 11.2155C12.3904 11.0718 12.2122 11 11.9998 11C11.7871 11 11.609 11.0718 11.4655 11.2155C11.3218 11.3593 11.25 11.5375 11.25 11.75V16C11.25 16.2125 11.3219 16.3906 11.4658 16.5343C11.6096 16.6781 11.7878 16.75 12.0003 16.75ZM12 9.2885C12.2288 9.2885 12.4207 9.21108 12.5755 9.05625C12.7303 8.90142 12.8077 8.70958 12.8077 8.48075C12.8077 8.25192 12.7303 8.06008 12.5755 7.90525C12.4207 7.75058 12.2288 7.67325 12 7.67325C11.7712 7.67325 11.5793 7.75058 11.4245 7.90525C11.2697 8.06008 11.1923 8.25192 11.1923 8.48075C11.1923 8.70958 11.2697 8.90142 11.4245 9.05625C11.5793 9.21108 11.7712 9.2885 12 9.2885ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill={isDarkMode ? "white" :"#4E4E4E"}/>
  </g>
</svg>
  )

const SubscriptionManagement = () => {
  const { t,i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  //const [isEditSubscription, setIsEditSubscription] = useState(false);
  const isEditSubscription = location.pathname === "/manageSubscriptionsEdit"
  const [state, ] = useContext(AsaStateContext)
  const fintechLaoyut = useFintechLayouts() //getLayoutFromFintech(fintech);
  const subscriptions = useActiveSubscriptions()
  const activeSubscription = Array.isArray(subscriptions?.data) ? subscriptions?.data?.[0] : undefined
  const { data: subscriptionsPlans } = useSubscriptionsPlans()
  const isChangePlanAvailable = (subscriptionsPlans?.length ?? 0) > 1
  const { data: paymentMethods } = usePaymentMethods()
  const sessionMutation = useAsaSessionPagesMutation();
  const { data: session } = useAsaSession();
  const isDarkMode=document.body.classList.contains('dark');
  useEffect(() => {
    AnalyticsService.track("Subscription Management Viewed", AnalyticsAction.View, AnalyticsFeature.Payment, {
      subscriptionName: activeSubscription?.subscriptionTitle,
      price: activeSubscription?.recurringAmount,
    });
  }, []);

  useEffect(() => {
    try {
      if (activeSubscription && activeSubscription.subscriptionStatus == "Canceled") {
        navigate("/cancelled");
      }
      if (!subscriptions.isLoading && !!!activeSubscription && !!state.url) {
        const currentUrl = new URL(state.url);
        navigate(currentUrl.pathname);
      }
    }
    catch (error) {
      console.log("error in subscription management", error)
    }
  }, [activeSubscription, state?.url, subscriptions]);

  const formatDate = (dateString: string | number | Date) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric", // Correctly typed as 'numeric'
      month: "long", // Correctly typed as 'long'
      day: "numeric", // Correctly typed as 'numeric'
    };
    const localeToUse = i18n.language || "en-US"; // Default to 'en-US' if locale is undefined
    return new Date(dateString).toLocaleDateString(localeToUse, options);
  };
  const updateTargetIfDifferent = async () => {
    const sessionToUpdate: IAsaSession = { ...session } as IAsaSession;
    const targetPage =
      session?.sessionPages?.find((page) => page.pageName === "GOALS PLANS") ||
      session?.sessionPages?.find((page) => page.pageName === "SelectedPlans");
    if (!targetPage) {
      console.error("Target page not found in session pages");
      return;
    }
    const parsedPageData = JSON.parse(targetPage.pageData.replace(/\\/g, ""));
    const pagePlanCode= parsedPageData?.subscriptionPlanCode;
    if(!!!pagePlanCode){
      console.error("Page data does not contain subscriptionPlanCode");
      return;
    }
    if( pagePlanCode === activeSubscription?.subscriptionPlanCode) {
      //console.log("No update needed, current plan matches the target page plan");
      return;
    }
    sessionToUpdate.sessionPages = undefined;
    const sessionpages = [] as SessionPage[];
    sessionpages.push({
      pageNumber: 2,
      pageName: targetPage.pageName,
      pageTitle: targetPage.pageTitle,
      pageDescription: targetPage.pageDescription,
      pageUrl: targetPage.pageUrl,
      pageStatusMessage: "INCOMPLETE",
      pageData: JSON.stringify(activeSubscription),
    } as SessionPage);

    try {
      const response = await sessionMutation.mutateAsync({
        asaSession: sessionToUpdate,
        extraPages: sessionpages,
      });
      return response;
    } catch (error) {
      console.error("Error updating session:", error);
    }
  };
  const handleManageTrialClick = () => {
    AnalyticsService.track("Manage Plan Clicked", AnalyticsAction.Click, AnalyticsFeature.Payment, {
      subscriptionName: activeSubscription?.subscriptionTitle,
    });
    //setIsEditSubscription(true);
    navigate("/manageSubscriptionsEdit");
  };

  const handleManagePayment = async () => {
    AnalyticsService.track("Change Payment Method Clicked", AnalyticsAction.Click, AnalyticsFeature.Payment, {
      subscriptionName: activeSubscription?.subscriptionTitle,
    });
    await updateTargetIfDifferent();
    navigate('/subscriptionpayment',{ state: { from: "subscriptionmanagement" } })
  };

  const handleCancelEditMode = () => {
    AnalyticsService.track("Cancel Edit Mode Clicked", AnalyticsAction.Click, AnalyticsFeature.Payment);
    //setIsEditSubscription(false);
    //console.log("handlecancel")
    navigate("/manageSubscriptions");
     //navigate("/cancelSubscription");
  };
  const handleManageSubscription = (forceCancel: boolean | undefined) => {
    AnalyticsService.track(
      forceCancel ? "Cancel Plan Clicked" : "Change Plan Clicked",
      AnalyticsAction.Click,
      AnalyticsFeature.Payment,
      { subscriptionName: activeSubscription?.subscriptionTitle },
    );
    //setIsEditSubscription(false);
    if (isChangePlanAvailable && !forceCancel) {
      if (!!state.url) {
        const currentUrl = new URL(state.url);
        navigate(currentUrl.pathname);
      } else {
        navigate(-1);
      }

    } else {
      navigate("/cancelSubscription");
    }
  };

  const getImageSource = (type: string | undefined, paymMethodCode: number | undefined) => {
    const cardNumber = paymentMethods?.find((item) => item?.asaPaymentMethodCode == paymMethodCode)?.cardNumber
    switch (type) {
      case "ACH":
        return check_everyday;
      case "Bank":
        return check_everyday; // Assuming Bank uses the same image as check_everyday
      case "Visa":
        return visa;
      case "CC":
        if (cardNumber?.startsWith("4")) {
          return visa
        } else if (cardNumber?.startsWith("3")) {
          return amex
        } else if (cardNumber?.startsWith("5")) {
          return city_double_cash
        }
          return cc_generic;
      default:
        return pwa_image;
    }
  };
  const getPaymentMethodLastDigits = () => {
    if (activeSubscription?.paymentType == "ACH") {
      return activeSubscription?.bankAccountNumberLast4
    }
    return activeSubscription?.cardNumberLast4

  }
  const stylePlanStatus = { color: fintechLaoyut?.buttonStyle?.background };
  const isPaid = !!activeSubscription && !activeSubscription.inTrial && !activeSubscription.isFree;
  const byllingCycleName = activeSubscription?.billingCycle?.toLowerCase() ==="monthly"?
    t("monthly"):t("annually");
  return (
    <SubscriptionManagementBase>
      <div className="flex flex-col flex-grow justify-between mx-5 mb-5 text-center">

      
         
            {/* Icon Section */}
            <div className="flex items-center justify-center">
              <div className="relative p-4 rounded-full">
                <SubscriptionManagementLogo layout={fintechLaoyut} isPaid={isPaid} />

              </div>
            </div>

            {/* Free Trial Info */}
            {activeSubscription?.inTrial && (
              <p className="text-[#46B601] font-medium font-poppins" style={stylePlanStatus}>
                <span className="mr-2">•</span>{t("freeTrialInProgress")}
              </p>
            )}
            {!activeSubscription?.inTrial && !activeSubscription?.isFree && (
              <p className="text-[#46B601] font-medium font-poppins mb-3" style={stylePlanStatus}>
                <span className="mr-2">•</span>{t("paidPlan")}
              </p>
            )}
            {!activeSubscription?.inTrial && activeSubscription?.isFree && (
              <p className="text-[#46B601] font-medium font-poppins mb-3" style={stylePlanStatus}>
                <span className="mr-2">•</span>{t("freePlan")}
              </p>
            )}
            <h1 className="text-xl  font-semibold">
              {activeSubscription?.subscriptionTitle}
            </h1>

            {/* Trial end date */}
            <div className="dark:bg-[#2C2C2C] bg-[#D9D9D9]  rounded-lg p-2 relative mt-4 flex flex-col items-center">
              <div className="absolute top-2 left-2">
                  {infoIcon(isDarkMode)}
              </div>
              {activeSubscription?.inTrial && (
                <div className="flex flex-col items-center">
                  <div className="flex flex-col">
                    <p className="text-center font-poppins text-base font-semibold leading-6 tracking-[-0.1px]">{t("yourFreeTrialWillEndOn")}</p>
                    <p className="text-center font-poppins text-base font-semibold leading-6 tracking-[-0.1px]">
                      {activeSubscription?.subscriptionEndDate
                        ? formatDate(activeSubscription?.subscriptionEndDate)
                        : "N/A"}
                    </p>
                    <p className=" text-center font-poppins text-xs font-semibold leading-6 tracking-tight mt-1 whitespace-nowrap">
                      <span className="opacity-50">{t("afterTrialBilling", { amount: activeSubscription?.recurringAmount })}</span>
                    </p>
                  </div>
                </div>
              )}
              {!activeSubscription?.inTrial && (
                <>
                  <p className="text-center font-poppins text-base font-semibold leading-6 tracking-[-0.1px] font-poppins">
                    {t("billedCycle", { cycle: byllingCycleName })}
                  </p>
                  <p className="text-center font-poppins text-xs font-normal leading-6 tracking-[-0.1px] mt-1">
                    <span className="opacity-50 font-poppins">{t("cancelAnytime")}</span>
                  </p>
                </>
              )}
            </div>

            {/* Payment Info */}
            <div className="text-left mt-6 ">
              {!isEditSubscription && (
                <>
                  <div className="flex justify-between mb-2">
                    <span className="font-poppins text-xs font-medium leading-6 opacity-80">{t("plan")}</span>
                    <span className="text-right font-poppins text-xs font-semibold leading-6">{activeSubscription?.subscriptionTitle}</span>
                  </div>
                  <div className="flex justify-between mb-2">
                    <span className="font-poppins text-xs font-medium leading-6 opacity-80">{t("nextPayment")}</span>
                    <span className="text-right font-poppins text-xs font-semibold leading-6">
                      {activeSubscription?.subscriptionEndDate
                        ? formatDate(activeSubscription?.subscriptionEndDate)
                        : "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between mb-2">
                    <span className="font-poppins text-xs font-medium leading-6 opacity-80">{t("paymentMethod")}</span>
                    {!(activeSubscription?.isFree ?? false) && (
                      <span className="flex items-center space-x-2">
                        <span className="mr-2 text-right font-poppins text-xs font-semibold leading-6">•••• {getPaymentMethodLastDigits()}</span>
                        <span className="bg-white p-1 rounded-md text-xs">
                          <img
                            src={getImageSource(activeSubscription?.paymentType, activeSubscription?.asaPaymentMethodCode)}
                            alt={activeSubscription?.paymentType || t("noPaymentMethod")}
                            className="w-8 h-5 rounded m"
                            style={{ objectFit: "contain" }}
                          />
                        </span>
                      </span>
                    )}
                  </div>
                  <div className="flex justify-between">
                    <span className="font-poppins text-xs font-medium leading-6 opacity-80">{t("total")}</span>
                    <span className="text-right font-poppins text-xs font-semibold leading-6">${activeSubscription?.recurringAmount}</span>
                  </div>
                </>
              )}
              {isEditSubscription && (
                <>
                  <div className="flex justify-between">
                    <span className="font-poppins text-xs font-medium leading-6 opacity-80">{t("subscriptionTitle")}</span>
                    <span className="text-right font-poppins text-xs font-semibold leading-6">{activeSubscription?.subscriptionTitle}</span>
                  </div>
                  <div className="w-full text-right mb-3" onClick={(e) => handleManageSubscription(false)}>
                    <p className="text-xs font-poppins font-bold leading-6 tracking-normal text-right" style={fintechLaoyut?.invertedbuttonStyle}>
                      {isChangePlanAvailable ? t("changePlan") : t("cancelPlan")}
                    </p>
                  </div>
                  <div className="flex justify-between mt-2">
                    <span className="font-poppins text-xs font-medium leading-6 opacity-80">{t("paymentMethod")}</span>
                    <span className="flex items-center space-x-2">
                      <span className="text-right font-poppins text-xs font-semibold leading-6">•••• {getPaymentMethodLastDigits()}</span>
                      <span className="bg-white text-white p-1 rounded-md text-xs">
                        <img
                          src={getImageSource(activeSubscription?.paymentType, activeSubscription?.asaPaymentMethodCode)}
                          alt={activeSubscription?.paymentType || t("noPaymentMethod")}
                          className="w-8 h-5 rounded m"
                          style={{ objectFit: "contain" }}
                        />
                      </span>
                    </span>
                  </div>
                  <div className="w-full text-right" onClick={handleManagePayment}>
                    <p className="text-xs font-poppins font-bold leading-6 tracking-normal text-right" style={fintechLaoyut?.invertedbuttonStyle}>
                      {t("changePaymentMethod")}
                    </p>
                  </div>
                </>
              )}
            </div>

        
         <div className="flex flex-row flex-1 mt-6 w-full justify-center items-end">
           {!isEditSubscription ? (
             <div className="mt-6 flex w-full justify-center items-center h-[51px]"> 
               <button
                 className="w-1/2 border dark:border-white border-[#4E4E4E] flex text-center dark:text-[#D8D8D8] text-[#4E4E4E] mx-3 py-3 px-3 rounded-lg shadow-md font-poppins font-semibold uppercase justify-center "
                 onClick={(e)=> handleManageSubscription(true)}
               >
                {activeSubscription?.inTrial?t("cancelTrial"):t("cancelPlan") }

               </button>

               <button
                 onClick={handleManageTrialClick}
                 className="w-1/2 flex disabled:opacity-50 justify-center  mx-3 py-3 px-3 rounded-[10px] bg-[#46B601] shadow-[0_4px_4px_rgba(0,0,0,0.25)] text-white text-center font-poppins text-sm font-bold leading-5 tracking-[-0.1px] uppercase"
                 style= {fintechLaoyut?.buttonStyle }
                 disabled={activeSubscription?.isFree??false}
               >
                {activeSubscription?.inTrial?t("manageTrial"):t("managePlan")}
                
               </button>
             </div>
           ) : (
             <button
               onClick={handleCancelEditMode}
               className="border dark:border-white border-[#4E4E4E] flex text-center dark:text-[#D8D8D8] text-[#4E4E4E] mx-5 py-3 px-3 rounded-lg shadow-md font-poppins font-semibold uppercase justify-center w-full"
             >
               { t("cancel") }
             </button>
           )}
          </div>
          
        
      </div>
    </SubscriptionManagementBase>
  );
};

export default SubscriptionManagement;
